import { styled } from 'next-yak';
import { Text } from 'components';

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.8rem;

  background-color: #16110E;
  color: var(--text_light);
  font-size: 1.4rem;
  padding: 1.6rem var(--layout-padding-side);

  p {
    color: inherit;
  }

  @media (min-width: 767px) {
    flex-direction: row;
    gap: 1.6rem;

    justify-content: space-between;

    padding: var(--layout-padding-side);
  }
`;

export const Socials = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;

  @media (min-width: 767px) {
    gap: 0.8rem;
  }
`;

export const Copyright = styled(Text)`
  @media (min-width: 767px) {
    text-align: right;
  }
`;
